import React, { useState, useEffect, useContext } from 'react'
import { CartContext } from '../../../providers/CartProvider';

import './static/Variantes.css'

const SeleccionVariantes = ({
  recursosUrlState,
  productsGroup,
  goToSlide,
}) => {

  const { procomponents, components, shoppingCart, addProductToCart } = useContext(CartContext);

  // Productos que tienen disponibilidad en la talla seleccionada
  const [availableProducts, setAvailableProducts] = useState([]);
  // Lista de tallas disponibles
  const [sizesList, setSizesList] = useState([]);
  // Talla seleccionada
  const [selectSize, setSelectSize] = useState(null);
  // Variante seleccionada
  const [selectVariant, setSelectVariant] = useState(null);
  // Unidades disponibles
  const [availableUnits, setAvailableUnits] = useState(1);
  // Unidades pedidas
  const [units, setUnits] = useState(1);

  /** Filta los productos que tienen disponibilidad en la talla seleccionada */
  const filterProductsOnSelectSize = () => {
    const filter = productsGroup.filter(product =>
      product.Variantes[0].Tallas.some(size =>
        size.Talla === selectSize && (size.Cantidad > 0 || size.Componente > 0)
      )
    )
    setAvailableProducts(filter);
    return filter;
  }

  /** Una talla estara disponible si su componente esta habilitado */
  const isAvailableSize = (code) => {
    const listComponent = Array.from(procomponents.keys());
    return listComponent.includes(code);
  }

  /** Obtiene la lista de tallas de todos los productos */
  const getSizes = () => {
    let sizes = new Set();
    productsGroup.forEach((product) => {
      product.Variantes[0].Tallas.forEach((size) => {
        if (size.Cantidad > 0 || isAvailableSize(product.Referencia + size.Talla)) {
          sizes.add(size.Talla);
        }
      })
    });
    const list = Array.from(sizes);
    setSizesList(list);
    setSelectSize(list[0]);
  }

  /** Obtiene las unidades disponibles del producto en la talla seleccionada */
  const getStockSizes = (variant) => {
    const stock = variant.Variantes[0].Tallas.find(size =>
      size.Talla === selectSize
    );
    const availableComponent = components.get(procomponents.get(variant.Referencia + selectSize)) || 0;
    let available = stock.Cantidad + Math.max(availableComponent, 0);
    const cartProduct = getProductCart(variant.Referencia + selectSize);
    if (cartProduct) {
      available -= cartProduct.Cantidad
    }
    setAvailableUnits(available);
  }

  const handleButtonUnits = (action) => {
    if (action === 'add') {
      if (availableUnits > units) {
        setUnits(units + 1);
      }
    } else {
      if (units > 1) {
        setUnits(units - 1);
      }
    }
  }

  /** Obtiene un producto del carrito */
  const getProductCart = (reference) => {
    const cart = shoppingCart;
    const cartProduct = cart.find((item) => item.Codigo === reference);
    return cartProduct || null;
  }

  /** Agrega productos o unidades al carrito */
  const addProductCart = () => {
    addProductToCart(selectVariant, selectSize, units);
    setUnits(1);
    setAvailableUnits(availableUnits - units);
  }

  useEffect(() => {
    setSelectVariant(availableProducts[0]);
  }, [availableProducts])

  useEffect(() => {
    if (selectSize != null) {
      const filterProducts = filterProductsOnSelectSize();
      const variant = filterProducts[0];
      setSelectVariant(variant);
      setUnits(1);
      getStockSizes(variant);

    }
  }, [selectSize])

  useEffect(() => {
    if (selectVariant != null) {
      getStockSizes(selectVariant);
      setUnits(1);
    }
  }, [selectVariant])

  useEffect(() => {
    getSizes();
  }, [productsGroup])
   
  return (
    <div>
      <h6 style={{fontWeight: 'bold', margin: '15px 0'}}>Talla</h6>
      <div style={{ display: 'flex', gap: '10px'}}>
      {
        sizesList.map(size => (
          <img
            style={{width:'30px'}}
            key={size}
            src={ size == selectSize
              ? `${recursosUrlState}/img/Filtros/${size}-negro.webp`
              : `${recursosUrlState}/img/Filtros/${size}-blanco.webp`
            }
            alt={size}
            onClick={() => setSelectSize(size)}
          />
        ))
      }
      </div>

      <h6 style={{fontWeight: 'bold', margin: '15px 0'}}>Color</h6>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
      {
        availableProducts.map((product) => (
          <div key={`variant-${product.Referencia}`}>
            <img
              className='img-variant'
              style={ product.Referencia === selectVariant?.Referencia? {border: 'solid 2px rgb(0, 0, 0)'} : {}}
              src={`${recursosUrlState}/img/Productos/Ref%20${product.Referencia}.webp`}
              alt={product.Referencia}
              onError={(e) => e.target.src = `${recursosUrlState}/img/General/base2.png`}
              onClick={() => {
                setSelectVariant(product);
                goToSlide(product.Referencia);
              }}
            />
          </div>
        ))
      }
      </div>

      <h6 style={{fontWeight: 'bold', margin: '15px 0'}}>
        Referencia: {selectVariant?.Referencia}
      </h6>

      <div className='div-order'>
        <div className='div-units'>
          <button
            className='btn-units'
            onClick={() => handleButtonUnits('remove')}
          > - </button>
          <input
            className='input-units'
            type='number'
            value={units}
            onChange={({target}) => {setUnits(parseInt(target.value))}}
            readOnly
          />
          <button
            className='btn-units'
            onClick={() => handleButtonUnits('add')}
          > + </button>
        </div>

        <button
          className='add-cart'
          onClick={() => addProductCart()}
        >
          Agregar al carrito
        </button>

      </div>

    </div>
  )
}

export default SeleccionVariantes